import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'dafAccount';

export interface FormValues {
  dafAccount: string | null;
}

export const validation = yup.object().shape({
  dafAccount: yup
    .string()
    .nullable()
    .required('You need to select a DAF account to proceed.'),
});
